(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partner-discount-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.partner-card__code-copy:not([data-processed])').forEach(btn => {
      btn.dataset.processed = 1;
      btn.addEventListener('click', function () {
        const code = btn.getAttribute('data-code'),
          textEl = btn?.querySelector('.partner-card__copy-text');
        if (!code || !textEl) return;

        navigator.clipboard
          ? navigator.clipboard.writeText(code).then(showCopied, fallbackCopy)
          : fallbackCopy();

        function showCopied() {
          textEl.textContent = 'Copied!';
          setTimeout(() => {
            textEl.textContent = text;
          }, 2000);
        }

        function fallbackCopy() {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.cssText = 'position:fixed;top:-999px;left:-999px;opacity:0;';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); showCopied(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rainshadow-blog-post"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        document.addEventListener('click', (e) => {
            let target = e.target.closest('[data-rainshadow-toc-link]');
            if (target) {
                function scrollTo(section, elem) {
                    window.scrollTo({
                        top: elem.getBoundingClientRect().y - section.getBoundingClientRect().y,
                        behavior: 'smooth',
                    });
                }
                const section = e.target.closest('.rainshadow-blog-post[data-rainshadow-section-id]'),
                    articleId = section.dataset.rainshadowArticleId,
                    article = section.querySelector(`.rainshadow-blog-post-article[data-rainshadow-article-id="${articleId}"]`),
                    data = parseInt(target.dataset.rainshadowTocLink);
                if (!isNaN(data)) {
                    console.log({section, article, articleId});
                    const tags = article && article.querySelectorAll(target.dataset.rainshadowTocTag);
                    if (tags && tags.length && tags[data]) {
                        scrollTo(section, tags[data]);
                    }
                } else {
                    const faq = section.querySelector(`.rainshadow-blog-post-faq[data-rainshadow-faq-id="${target.dataset.rainshadowTocLink}"]`);
                    console.log({section, target, faq});
                    if (faq) {
                        scrollTo(section, faq);
                    }
                }
            }
            target = e.target.closest('[data-rainshadow-expandable]');
            if (target) {
                target.classList.toggle(target.dataset.rainshadowExpandable);
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rainshadow-blog"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        function searchByTagged(blogHandle, tagHandle) {
            const path = `/blogs/${blogHandle}` + (tagHandle ? `/tagged/${tagHandle}` : '');
            if (path !== window.location.pathname) {
                window.location.href = path + window.location.search;
            }
        }
        const selects = document.querySelectorAll('.rainshadow-blog-explore-categories-select') || [];
        selects.forEach(s => {
            s.addEventListener('change', () => {
                if (s.value) {
                    searchByTagged(s.dataset.rainshadowBlogHandle, s.value === '/' ? null : s.value);
                }
            });
        });
    });

  } catch(e) { console.error(e); }
})();
})();
